import { AuthPanel } from "@/ui/AuthPanel"

export const Register = () => <AuthPanel mode="register" />
